import React from 'react'
import { Text } from '@mindfulchefuk/design-system'

export const OnboardingBasketFooterEmpty = ({
  min,
  max,
}: {
  min: number
  max: number
}) => (
  <Text as="span" variant={['body-sm-500-caps', 'body-xl-500-caps']}>
    Add {min} to {max} recipes
  </Text>
)
